 import {
  FeatureFlagKey,
  FEATURE_FLAGS_INITIAL_STATE,
} from "@/modules/common/context/feature-flags.constants";
import { FeatureFlagsContextType } from "@/modules/common/context/feature-flags.types";
import useAuth from "@/modules/common/hooks/auth.hook";
import useLocalStorageState from "@/modules/common/hooks/local-storage.hook";
import { useQuery } from "@tanstack/react-query";
import { createContext, ReactNode, useCallback, useEffect, useMemo } from "react";
import { getUserFeatureFlags } from "@/modules/common/api/index.v2";
  
export const FeatureFlagsContext =
  createContext<FeatureFlagsContextType>(FEATURE_FLAGS_INITIAL_STATE);

const FeatureFlagsProvider = ({ children }: { children: ReactNode }) => {
  const { user } = useAuth();
  
   const [flags, setFlags] = useLocalStorageState(`featureFlags`, {});

 
  const { data: featureFlagsData, error } = useQuery({
    queryKey: ["featureFlags", user?.sub],
    queryFn: async () => {
     return await getUserFeatureFlags( );
     },
    enabled: !!user,
    staleTime: 1000 * 60 * 5,
  });

  useEffect(() => {
    if (featureFlagsData) {
       setFlags(featureFlagsData.data);
    } else if (error) {
       setFlags({});
    }  
  }, [featureFlagsData, error, setFlags]);

  const hasFlag = useCallback(
    (key: FeatureFlagKey): boolean => {
      const result = !!flags[key];
       return result;
    },
    [flags],
  );

  const contextValue = useMemo(() => ({ flags, hasFlag }), [flags, hasFlag]);

  return (
    <FeatureFlagsContext.Provider value={contextValue}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};

export default FeatureFlagsProvider;
